<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponente
        :aplica-busqueda-fecha="true"
        :icono="icono"
        :titulo="titulo"
        :codigoTitulo="codigoTitulo"
        :subTitulo="subTitulo"
        :cifrasControl="cifrasControl"
        :datosTabla="datosTabla"
        :resource="resource"
        :slas="slas"
        @_funcionExtra="getObtenerDatosBandeja"
        @_funcionExtra2="abrirModalObservaciones"
        @_actualizaFecha="actualizarFecha"
        @_filtrarSemaforo="filtrarSemaforo"
        @_limpiarSemaforo="limpiarSemaforo"
    >
    </BandejaComponente>
    <!-- Modal de observaciones-->

    <b-modal
        ref="observaciones"
        title="Observaciones Diagnóstico"
        hide-footer
    >
      <br />
      <h4 v-if="solicitud !== null" class="my-4 text-left">{{ solicitud.observacionesDiagnostico }}</h4>
      <br />
      <b-button
          class="mt-3"
          variant="outline-info"
          block
          @click="cerrarModal('observaciones')"
      >Cerrar</b-button
      >
      <br /><br/>
    </b-modal>
  </div>
</template>

<script>
import BandejaComponente from "../components/bandejas/BandejaComponente.vue";
import Swal from "sweetalert2";
import miniToastr from "mini-toastr";
export default {
  name: "BandejaEmbajadorSeguimiento",
  components:{
    BandejaComponente
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fechaFin: "",
    fechaIncio: "",
    idEmpleado: null,
    idClinica: null,
    idUsuario: null, 
    idPaciente: 0,
    datosTabla: [],
    icono: "fa fa-credit-card",
    titulo: "EMBAJADOR",
    codigoTitulo: "BJ_Seg_EE_PTI",
    subTitulo: "Bandeja de Seguimiento del Embajador",
    idEstatusPestañaSeleccionada : 1,
    resource: {
      permiteCambiarDiagnosticador: null,
      idEstatusSolicitud: null,
      arrayDoctorEmbajador: [],
    },
    encabezadosAceptadosPagoParcial: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "dteFechaSesion",
        label: "Inicio de sesión",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dtehoraInicio",
        label: "CDX inicia PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dtehoraFinal",
        label: "CDX termina PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkSeguimientoPTIComponente",
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true,
        component: "SelectEmbajadorComponente",
      },
      {
        key: "intIdNivelPTI",
        label: "Nivel",
        sortable: true,
      },
      {
        key: "codigoColor",
        label: "SLA",
        sortable: true,
        component: "SemaforoSLA"
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },
    ],
    encabezadosAceptadosNoPagados: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "dteFechaSesion",
        label: "Inicio de sesión",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dtehoraInicio",
        label: "CDX inicia PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dtehoraFinal",
        label: "CDX termina PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkSeguimientoPTIComponente",
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true,
        component: "BandejaEmbajadorComponente",
      },
      {
        key: "intIdNivelPTI",
        label: "Nivel",
        sortable: true,
      },
      {
        key: "codigoColor",
        label: "SLA",
        sortable: true,
        component: "SemaforoSLA"
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },

    ],
    encabezadosRechazados: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "dteFechaSesion",
        label: "Inicio de sesión",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dtehoraInicio",
        label: "CDX inicia PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtehoraFinal",
        label: "CDX termina PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkSeguimientoPTIComponente",
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true,
        component: "BandejaEmbajadorComponente",
      },
      {
        key: "intIdNivelPTI",
        label: "Nivel",
        sortable: true,
      },
      {
        key: "codigoColor",
        label: "SLA",
        sortable: true,
        component: "SemaforoSLA"
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },
    ],
    encabezadosPagadosTxPendientes: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "dteFechaSesion",
        label: "Inicio de sesión",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dtehoraInicio",
        label: "CDX inicia PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtehoraFinal",
        label: "CDX termina PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkSeguimientoPTIComponente",
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true,
        component: "BandejaEmbajadorComponente",
      },
      {
        key: "intIdNivelPTI",
        label: "Nivel",
        sortable: true,
      },
      {
        key: "codigoColor",
        label: "SLA",
        sortable: true,
        component: "SemaforoSLA"
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },

    ],
    encabezadosHistoricos: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "dtefechaAlta",
        label: "Fecha de ingreso a bandeja",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dtehoraInicio",
        label: "CDX inicia PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtehoraFinal",
        label: "CDX termina PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkSeguimientoPTIComponente",
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true,
        component: "BandejaEmbajadorComponente",
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },

    ],
    encabezadosHistoricosv9: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "dtehoraInicio",
        label: "CDX inicia PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtehoraFinal",
        label: "CDX termina PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true,
        component: "BandejaEmbajadorComponente",
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },
      {
        key: "fin",
        label: "Finalizar",
        sortable: true,
        component: "BotonFinSolicitud",
      },
    ],
    encabezadosVisiblePti: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "dtefechaAlta",
        label: "Fecha de la solicitud",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "LinkPacientePtiVisibleComponente",
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      }
    ],
    encabezadosVisiblePtiV5: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "dtefechaAlta",
        label: "Fecha de la solicitud",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "LinkPacientePtiVisibleComponenteV5",
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      }
    ],
    cifrasControl: [
     {
      id: 2,
      nombre: "Rechazados",
      cantidad: 0,
      icono: "x-circle",
      layoutTabla: [],
      visible: true,
      permiso: "Seg_PTI_rechazado"
    },{
        id: 5,
        nombre: "Históricos v10.0",
        cantidad: 0,
        icono: "bookmark-star",
        layoutTabla: [],
        visible: true,
        permiso: "Seg_PTI_Acep_historico_v10"
      },
      {
        id: 6,
        nombre: "Históricos v9.0",
        cantidad: 0,
        icono: "bookmark",
        layoutTabla: [],
        visible: true,
        permiso: "Seg_PTI_Acep_historico_v9"
      },
      {
        id: 1,
        nombre: "Aceptados con pago parcial",
        cantidad: 0,
        icono: "wallet-fill",
        layoutTabla: [],
        visible: false,
        permiso: "Seg_PTI_Acep_pago_parcial"
      },
      {
        id: 3,
        nombre: "Aceptados no pagados",
        cantidad: 0,
        icono: "wallet2",
        layoutTabla: [],
        visible: false,
        permiso: "Seg_PTI_Acep_no_pagado"
      },

      {
        id: 4,
        nombre: "Pagados con Tx Pendientes",
        cantidad: 0,
        icono: "heart-half",
        layoutTabla: [],
        visible: false,
        permiso: "Seg_PTI_Acep_Tx_pendientes"
      },

      {
        id: 7,
        nombre: "Pti visibles",
        cantidad: 0,
        icono: "heart-half",
        layoutTabla: [],
        visible: true,
        permiso: "Seg_PTI_Visible"
      },
      {
        id: 8,
        nombre: "Pti visibles V5",
        cantidad: 0,
        icono: "heart-half",
        layoutTabla: [],
        visible: true,
        permiso: "Seg_PTI_Visible"
      },


    ],
    solicitud: null,
    slas: [],
  }),
  methods: {
    getObtenerDatosBandeja(intIdEstuatusSolicitud) {
      this.showAlert();
      this.datosTabla = [];
      this.idEstatusPestañaSeleccionada = intIdEstuatusSolicitud;
    if(intIdEstuatusSolicitud==6){
        this.$http
          .get(
              this.$api +
              "pti/bandeja/embajador/seguimiento/historicos?fechaFinal=" +
              this.fechaFin +
              "&fechaIncio=" +
              this.fechaInicio +
              "&idPaciente=" +
              this.idPaciente+
              "&idClinica=" +
              this.idClinica
          ).then(respuesta => {this.resource.idEstatusSolicitud = intIdEstuatusSolicitud;
            this.datosTabla=respuesta.data.data;
            Swal.close();
          })
            .catch((error) => {
            console.error(error);
            miniToastr.warn("No se encotraron resultados");
            Swal.close();
          }).finally(() => {
        this.getCifrasPorEstatus();
        this.getSLATipoSolicitud(intIdEstuatusSolicitud);
      });
    }else{
    const parametros = {
      fechaFinal: this.fechaFin,
      fechaIncio: this.fechaInicio,
      idEmpleado: this.idEmpleado,
      intIdEstuatusSolicitud: intIdEstuatusSolicitud,
      idClinica: this.idClinica,
      idPaciente: this.idPaciente
    }
      this.$http
          .post(
              this.$api +
              "pti/bandeja/embajador/seguimiento/aceptados", parametros
          )
          .then((response) => {
            //NO devuelve un array asi que no funciona validar isArray
            this.resource.permiteCambiarDiagnosticador =
                response.data.data.blnPermiteEditar;
            this.resource.idEstatusSolicitud = intIdEstuatusSolicitud;
            this.datosTabla = response.data.data.listaResultados;
            Swal.close();
          })
          .catch((error) => {
            console.error(error);
            miniToastr.warn("No se encotraron resultados");
            Swal.close();
          }).finally(() => {
        this.getCifrasPorEstatus();
        this.getSLATipoSolicitud(intIdEstuatusSolicitud);
      });
    }
    },
    getCifrasPorEstatus() {
      const params = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        idClinica: this.idClinica,
        idPaciente: this.idPaciente
      }
      this.$http
          .post(
              this.$api +
              "pti/bandeja/embajador/cifrasPorEstatus/seguimientos", params )
          .then((response) => {

            if (Array.isArray(response.data.data) == true) {
              var data = response.data.data;
              data.forEach((elemento) => {
                if (elemento.idEstatusSolicitud == 13) {
                  this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
                  this.cifrasControl[0].layoutTabla = this.encabezadosRechazados;
                }

                if (elemento.idEstatusSolicitud == 24) {
                  this.cifrasControl[1].cantidad = elemento.noTotalSolcitudes;
                  this.cifrasControl[1].layoutTabla = this.encabezadosHistoricos;
                }
                if (elemento.idEstatusSolicitud == 1) {
                  this.cifrasControl[2].cantidad = elemento.noTotalSolcitudes;
                  this.cifrasControl[2].layoutTabla = this.encabezadosHistoricosv9;
                }
                if (elemento.idEstatusSolicitud == 25) {
                  this.cifrasControl[6].cantidad = elemento.noTotalSolcitudes;
                  this.cifrasControl[6].layoutTabla = this.encabezadosVisiblePti;
                }
                if (elemento.idEstatusSolicitud == 27) {
                  this.cifrasControl[7].cantidad = elemento.noTotalSolcitudes;
                  this.cifrasControl[7].layoutTabla = this.encabezadosVisiblePtiV5;
                }

              });
            }
            Swal.close();
          })
          .catch((error) => {
            console.error(error);
            Swal.close();
          });
    },
    getSLATipoSolicitud(intIdEstuatusSolicitud) {

      let idTipoSolicitud = null;

      switch (intIdEstuatusSolicitud) {
        case 1:
          idTipoSolicitud = 17;
          break;
        case 2:
          idTipoSolicitud = 13;
          break;
        case 3:
          idTipoSolicitud = 22;
          break;
        case 4:
          idTipoSolicitud = 18;
          break;
        case 5:
          idTipoSolicitud = 24;
          break;
        case 7:
          idTipoSolicitud = 25;
          break;
        case 8:
          idTipoSolicitud = 27;
          break;
        case 6:
          idTipoSolicitud = 0;
          break;
      }
      const params = {
        idTipoSolicitud: idTipoSolicitud
      }

      this.$http
          .post(
              this.$api +
              "seguimiento/pti/obtener/sla/post", params )
          .then((response) => {
            if (Array.isArray(response.data.data) == true) {
              this.slas = response.data.data;
            }

          })
          .catch((error) => {
            console.error(error);
          });
    },
    actualizarFecha(fechaInicio, fechaFin, idPaciente) {
      if (fechaFin !== null && fechaInicio !== null){
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      this.getObtenerDatosBandeja(this.idEstatusPestañaSeleccionada);
    },
    filtrarSemaforo(sla) {
      this.datosTabla = this.datosTabla.filter((item) => item.codigoColor === sla.codigoColor);
    },
    limpiarSemaforo() {
      this.getObtenerDatosBandeja(this.idEstatusPestañaSeleccionada);
    },
    abrirModalObservaciones(data){
      this.solicitud = data;
      this.$refs["observaciones"].show();
    },
    cerrarModal(nombre){
      this.$refs[nombre].hide();
      this.solicitud = null;
    },
    getObtenerEncargadosClinica() {
      this.showAlert();
      this.$http
          .get(
              this.$api +
              "pti/bandeja/embajador/obtenerEncargadosClinica?idClinica=" +
              this.idClinica
          )
          .then((response) => {
            //NO devuelve un array asi que no funciona validar isArray
            if (Array.isArray(response.data.data) == true) {
              this.resource.arrayDoctorEmbajador = response.data.data;
            }
            Swal.close();
          })
          .catch((error) => {
            console.error(error);
            Swal.close();
          }).finally(() => {
        this.getObtenerDatosBandeja(2);
      });
    },
    

    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },

  },
  mounted() {
    this.getObtenerEncargadosClinica();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.resource = {
      permiteCambiarDiagnosticador: false,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();

    var dia1 = new Date();
    dia1.setDate(dia1.getDate() - 3);
    dia1.setHours(0, 0, 0, 0);
    this.fechaInicio = this.$moment(dia1)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        
  }
}
</script>

<style scoped>

</style>
